import React, { useState } from "react";
import { Modal, Button, Table, Typography } from "antd";
import { useAuth } from "context/AuthContext";
import ArrayUtils from "utils/arrays";
import UsuariosService from "services/UsuariosService";

const { Text } = Typography;

export default function ExclusaoUsuariosSelecionados({
  onCancel,
  usuarios,
  usuarioIds,
  obterAlturaDisponivelNaTela
}) {
  const [exibirModalConfirmacao, setExibirModalConfirmacao] = useState(true);
  const [emProcessamento, setEmProcessamento] = useState(false);
  const [processamentoFinalizado, setProcessamentoFinalizado] = useState(false);
  const [contagemProcessados, setContagemProcessados] = useState(0);
  const [listaErros, setListaErros] = useState([]);

  const {direito} = useAuth();

  const total = usuarioIds.length;
  const temErro = listaErros.length > 0;

  const handleConfirmar = async () => {
    setExibirModalConfirmacao(false);
    setEmProcessamento(true);
    setListaErros([]);
    setContagemProcessados(0);

    await processarExclusaoUsuarios();

    setEmProcessamento(false);
    setProcessamentoFinalizado(true);
  }

  async function processarExclusaoUsuarios() {
    const tamanhoBatch = 5;
    const idBatches = ArrayUtils.splitIntoBatches(usuarioIds, tamanhoBatch);

    for (const batch of idBatches) {
      const errosNoBatch = await processarBatchExclusao(batch);
      setListaErros(prev => [...prev, ...errosNoBatch]);
      setContagemProcessados(prev => prev + batch.length);
    }
  }

  async function processarBatchExclusao(batch) {
    const resultados = await Promise.all(
      batch.map(async (id) => {
        const usuario = usuarios.find((u) => u.id === id);
        const exclusaoDTO = {
          UsuarioId: id,
          TenantId: direito.axtTenantId,
          DireitoId: direito.entitlementId
        };

        try {
          await UsuariosService.ExcluirUsuario(exclusaoDTO);
          return null;
        } catch (error) {
          const erros = error.response?.data?.erros ?? ["Erro inesperado ao tentar excluir o usuário."];
          return { usuario, erros };
        }
      })
    );

    return resultados.filter(result => result !== null);
  }


  return (
    <>
      {
        exibirModalConfirmacao ?
          ModalConfirmacao() :
        emProcessamento ?
          ModalProcessamento() :
        processamentoFinalizado && temErro ?
          ModalErros() :
        processamentoFinalizado && !temErro ?
          ModalSucessoProcessamento() :
          null
      }
    </>
  );

  function ModalConfirmacao() {
    return <Modal
      open={exibirModalConfirmacao}
      title={`Tem certeza de que deseja excluir os ${usuarioIds.length} usuários selecionados?`}
      onCancel={() => onCancel()}
      width={800}
      centered
      footer={[
        <Button key="cancel" onClick={() => onCancel()} disabled={emProcessamento}>
          Cancelar
        </Button>,
        <Button key="confirm" type="primary" danger loading={emProcessamento} onClick={handleConfirmar}>
          Confirmar
        </Button>,
      ]} >
        <span>As exclusões dos usuários serão processadas, entretanto, as assinaturas vinculadas aos usuários continuarão disponíveis no ambiente para uso.</span>
      </Modal>;
  }

  function ModalProcessamento() {
    return <Modal
      open={emProcessamento}
      title={'Processando exclusões...'}
      closable={false}
      footer={null}
      centered
    >
      <div style={{ marginTop: 8 }}>
        <Text>{contagemProcessados} de {total} usuários processados</Text>
      </div>
    </Modal>;
  }

  function ModalErros() {
    const colunasComErro = [
      {
        title: "Usuário",
        key: "usuario",
        width: 500,
        render: (_, record) => {
          const usuario = record.usuario || {};
          return (
            <div>
              <Text strong>{usuario.displayName || "—"}</Text>
              <br />
              <Text type="secondary">{usuario.mail || "—"}</Text>
            </div>
          );
        }
      },
      {
        title: "Erros",
        key: "erros",
        width: 500,
        render: (_, record) =>
          record.erros.map((erro, idx) => (
            <div key={idx}>
              <Text type="danger">
                • {formatarMensagemErroParaIncluirLinkDoTaylorXpSeExistir(erro)}
              </Text>
            </div>
        )),
      },
    ];

    return <Modal
      open={processamentoFinalizado && temErro}
      title={'Veja os Erros'}
      footer={<Button key="close" type="primary" onClick={onCancel}>Fechar</Button>}
      onCancel={onCancel}
      centered
      width={1000}
    >
      <>
        <div style={{ margin: '16px 0' }}>
          <Typography.Text type="secondary">
            Alguns usuários foram impedidos de serem submetidos à exclusão.
          </Typography.Text>
        </div>
        <Table
          dataSource={listaErros}
          columns={colunasComErro}
          rowKey="id"
          pagination={false}
          tableLayout="auto"
          size="small"
          scroll={{ y: obterAlturaDisponivelNaTela() }}
        />
      </>
    </Modal>;
  }

  function formatarMensagemErroParaIncluirLinkDoTaylorXpSeExistir(erro) {
    const partes = erro.split(/(Taylor)/);
    return partes.map((parte, idx) =>
      parte === "Taylor" ? (
        <a
          key={idx}
          href={"https://xpinvestimentos.service-now.com/sp_assessor?id=sc_cat_item&sys_id=0ccd36d3dbb74c94ff1a9d40ba9619a1"}
          target="_blank"
          rel="noopener noreferrer"
        >
          {parte}
        </a>
      ) : (
        parte
      )
    );
  }

  function ModalSucessoProcessamento() {
    return <Modal
      open={processamentoFinalizado && !temErro}
      title={'Pedidos de exclusão submetidos com sucesso.'}
      footer={<Button key="close" type="primary" onClick={() => onCancel(true)}>Fechar</Button>}
      onCancel={() => onCancel(true)}
      centered />
  }
}